import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { GoodsStatus } from '@/interfaces/goods';
import { SnackType } from '@/interfaces/snack';
import { utcDateTimeToLocal, utcDateTimeToDate } from '@/utils/dateTime';
import { showErrors, showNotification } from '@/utils/snack';
import { findGood, deleteGood } from './gql';
import { statusCodes, statusOptions, GoodsStatusText } from '@/helpers/goods';
import AuthFilter from '@/mixins/auth-filter';
import { mixins } from 'vue-class-component';

var GoodsDialog = /*#__PURE__*/function (_mixins) {
  _inherits(GoodsDialog, _mixins);

  var _super = _createSuper(GoodsDialog);

  function GoodsDialog() {
    var _this;

    _classCallCheck(this, GoodsDialog);

    _this = _super.apply(this, arguments);
    _this.targetgoods = null;
    _this.deleteDialog = {
      show: false,
      title: '删除商品品类',
      text: ''
    };
    _this.statusOptions = statusOptions();
    _this.statusCodes = statusCodes();
    _this.GoodsStatusText = GoodsStatusText;
    _this.GoodsStatus = GoodsStatus;
    _this.utcDateTimeToLocal = utcDateTimeToLocal;
    _this.utcDateTimeToDate = utcDateTimeToDate;
    return _this;
  }

  _createClass(GoodsDialog, [{
    key: "isDefaultCover",
    value: function isDefaultCover(item) {
      return item.thumb === process.env.VUE_APP_DOMAIN + '/book_covers/hd_book_default_cover.png';
    }
  }, {
    key: "usingStatus",
    value: function usingStatus(status) {
      return {
        'u-tag-blue': status === this.GoodsStatus.ON_SHELVES,
        'u-tag-red': status === this.GoodsStatus.OFF_SHELVES
      };
    }
  }, {
    key: "addGoods",
    value: function addGoods() {
      this.$router.push({
        name: 'EditGoods',
        params: {
          type: 'new'
        }
      });
    }
  }, {
    key: "editGoods",
    value: function editGoods(item, type) {
      this.$router.push({
        name: 'EditGoods',
        params: {
          type: type,
          id: item.id,
          name: item.title
        }
      });
    }
  }, {
    key: "deleteGoods",
    value: function () {
      var _deleteGoods = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(goods) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.targetgoods = goods;
                this.deleteDialog.text = "\u662F\u5426\u786E\u5B9A\u5220\u9664\u5546\u54C1\u54C1\u7C7B \u201C".concat(goods.title, "\u201D ?");
                this.deleteDialog.show = true;

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function deleteGoods(_x) {
        return _deleteGoods.apply(this, arguments);
      }

      return deleteGoods;
    }()
  }, {
    key: "deleteGoodsRequest",
    value: function () {
      var _deleteGoodsRequest = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var id, result, typedError;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (this.targetgoods) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                id = this.targetgoods.id;
                this.deleteDialog.show = false;
                _context2.prev = 4;
                _context2.next = 7;
                return this.$apollo.mutate({
                  mutation: deleteGood,
                  variables: {
                    goodId: id
                  }
                });

              case 7:
                result = _context2.sent;

                if (result) {
                  showNotification({
                    msg: '删除成功!',
                    type: SnackType.Success
                  });
                }

                _context2.next = 15;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](4);
                typedError = _context2.t0;
                showErrors(typedError.graphQLErrors);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 11]]);
      }));

      function deleteGoodsRequest() {
        return _deleteGoodsRequest.apply(this, arguments);
      }

      return deleteGoodsRequest;
    }()
  }, {
    key: "getGoodsById",
    value: function () {
      var _getGoodsById = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(goodId) {
        var result, typedError;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.$apollo.query({
                  query: findGood,
                  variables: {
                    goodId: goodId
                  }
                });

              case 3:
                result = _context3.sent;
                return _context3.abrupt("return", result.data.findGood);

              case 7:
                _context3.prev = 7;
                _context3.t0 = _context3["catch"](0);
                typedError = _context3.t0;
                showErrors(typedError.graphQLErrors);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 7]]);
      }));

      function getGoodsById(_x2) {
        return _getGoodsById.apply(this, arguments);
      }

      return getGoodsById;
    }()
  }]);

  return GoodsDialog;
}(mixins(AuthFilter));

GoodsDialog = __decorate([Component({})], GoodsDialog);
export default GoodsDialog;